import React, { useState, useEffect } from 'react';
import DownloadSpeciesData from '../../../services/downloadSpeciesTable.jsx';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import '../../../styles/pages.css'; 




function SpeciesGlobalRegionalCoverageTable(props) {

         const { t } = useTranslation();
         const [dataSelected, setDataSelected] = useState("");
         const [dataAllSpeciesToDownload, setAllSpeciesToDownload] = useState("");
         const [selectedSection, setSelectedSection] = useState(1);
         const [totalLineData, setTotalLineData] = useState("");
         const [dataRefactored, setDataRefactored] = useState(false);
          const [globalUniqueASpeciesCount, setGlobalUniqueASpeciesCount] = useState("");

         //const sumAllAndDivideThou = (partialSum, a) => ((partialSum + a, 0)/1000);
       useEffect(() => {
        //  console.log(props.data);
         const refactorData = async () => {
                if(!dataRefactored) {
          const refactoredData = props.data.map(country => (
            { region : country.territory.region.name,
                species : country.submission_species.map(spec => ({
                species: spec.species.name,
                region: country.territory.region.name,
                territory: country.territory.name,
                national_distribution_available : spec.species_answers.filter(ans => ans.question === 133).length > 0 ? spec.species_answers.filter(ans => ans.question === 133)[0].value === "0"  ? 1 : 0 : 0,
                non_molecular_characterization: spec.species_answers.filter(ans => ans.question === 137).length > 0 ? spec.species_answers.filter(ans => ans.question === 137)[0].value === "0"  ? 1 : 0 : 0,
                molecular_characterization: spec.species_answers.filter(ans => ans.question === 140).length > 0 ? spec.species_answers.filter(ans => ans.question === 140)[0].value === "0"  ? 1 : 0 : 0,
                in_situ_programme: spec.species_answers.filter(ans => ans.question === 145).length > 0 ? spec.species_answers.filter(ans => ans.question === 145)[0].value === "0"  ?  1 : 0 : 0,
                number_situ_units: spec.species_answers.filter(ans => ans.question === 148).length > 0 ? spec.species_answers.filter(ans => ans.question === 148)[0].value : "",
                area_in_situ: spec.species_answers.filter(ans => ans.question === 151).length > 0 ? spec.species_answers.filter(ans => ans.question === 151)[0].value.replace(",", '.') : "",
                ex_situ_programme: spec.species_answers.filter(ans => ans.question === 155).length > 0 ? spec.species_answers.filter(ans => ans.question === 155)[0].value === "0"  ? 1 : 0 : 0,
                number_ex_situ: spec.species_answers.filter(ans => ans.question === 158).length > 0 ? spec.species_answers.filter(ans => ans.question === 158)[0].value : "",
                area_ex_situ: spec.species_answers.filter(ans => ans.question === 161).length > 0 ? spec.species_answers.filter(ans => ans.question === 161)[0].value.replace(",", '.') : "",
                number_ex_situ_accessions: spec.species_answers.filter(ans => ans.question === 164).length > 0 ? spec.species_answers.filter(ans => ans.question === 164)[0].value : "",
                national_tree_seed_prog: spec.species_answers.filter(ans => ans.question === 169).length > 0 ? spec.species_answers.filter(ans => ans.question === 169)[0].value === "0"  ? 1 : 0 : 0,
                tree_breeding_prog: spec.species_answers.filter(ans => ans.question === 172).length > 0 ? spec.species_answers.filter(ans => ans.question === 172)[0].value === "0"  ? 1 : 0 : 0,
                area_seed_stands: spec.species_answers.filter(ans => ans.question === 176).length > 0 ? spec.species_answers.filter(ans => ans.question === 176)[0].value.replace(",", '.') : "",
                number_seed_stands: spec.species_answers.filter(ans => ans.question === 257).length > 0 ? spec.species_answers.filter(ans => ans.question === 257)[0].value.replace(",", '.') : "",
                area_seed_orchards: spec.species_answers.filter(ans => ans.question === 179).length > 0 ? spec.species_answers.filter(ans => ans.question === 179)[0].value.replace(",", '.') : "",
                number_seed_orchards: spec.species_answers.filter(ans => ans.question === 259).length > 0 ? spec.species_answers.filter(ans => ans.question === 259)[0].value : "",
                planting_stock_year: spec.species_answers.filter(ans => ans.question === 182).length > 0 ? spec.species_answers.filter(ans => ans.question === 182)[0].value : "",
                state_tree_breeding_prog: spec.species_answers.filter(ans => ans.question === 186).length > 0 ? spec.species_answers.filter(ans => ans.question === 186)[0].value : "",
              }))}
            ));
         
            const sortedList = [...refactoredData];
            setAllSpeciesToDownload([]);
            const speciesList = [];
            console.log(sortedList);
            for (let i = 0; i < sortedList.length; i++) {
              speciesList.push(...sortedList[i].species);
                    }
           setAllSpeciesToDownload(speciesList);
          //  console.log(speciesList);
            sortedList.sort((a, b) => {
              const nameA = a.region.toUpperCase(); // ignore upper and lowercase
              const nameB = b.region.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
            
              return 0;
            });
            var uniqueList = []
            uniqueList = sortedList.map(record => record.region);
            setTotalLineData([...new Set(uniqueList)]);
         const reducedList = [];

       
         uniqueList.filter((o, index, arr) =>arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index).forEach((elem) => {
          var arraysMerged = [];
          sortedList.filter(record => record.region === elem).map(elem => arraysMerged.push(...elem.species))
          reducedList.push({
           region: elem,
           data:  arraysMerged
         
         })
        }
         ) 
          const uniqueGlobalSpecies = [];
           speciesList.forEach((spec) => {
            uniqueGlobalSpecies.push(
           spec.species);
      });
      // console.log(uniqueGlobalSpecies);
        const uniqueSpecies = Array.from(new Set(uniqueGlobalSpecies));
        console.log(uniqueSpecies);
       
          setGlobalUniqueASpeciesCount(uniqueSpecies.length);
 
       const  regionalValues = reducedList.map(region =>
          ({
            national_distribution_available : region.data.filter(element => element.national_distribution_available === 1).map(fil => ({species : fil.species, national_distribution_available: fil.national_distribution_available})),
            non_molecular_characterization : region.data.filter(element => element.non_molecular_characterization === 1).map(fil => ({species : fil.species, non_molecular_characterization: fil.non_molecular_characterization})),
            molecular_characterization : region.data.filter(element => element.molecular_characterization === 1).map(fil => ({species : fil.species, molecular_characterization: fil.molecular_characterization})),
           
            in_situ_programme : region.data.filter(element => element.national_distribution_available === 1).map(fil => ({species : fil.species, in_situ_programme: fil.in_situ_programme})),
            number_situ_units : region.data.map(rec => + rec.number_situ_units).reduce((partialSum, a) => partialSum + a, 0),
            area_in_situ : region.data.map(rec =>  + rec.area_in_situ).reduce((partialSum, a) => partialSum + a, 0),

            ex_situ_programme : region.data.filter(element => element.ex_situ_programme === 1).map(fil => ({species : fil.species, ex_situ_programme: fil.ex_situ_programme})),
            number_ex_situ : region.data.map(rec => + rec.number_ex_situ).reduce((partialSum, a) => partialSum + a, 0),
            area_ex_situ : region.data.map(rec => + rec.area_ex_situ).reduce((partialSum, a) => partialSum + a, 0),
            number_ex_situ_accessions : region.data.map(rec => + rec.number_ex_situ_accessions).reduce((partialSum, a) => partialSum + a, 0),

            national_tree_seed_prog : region.data.filter(element => element.national_tree_seed_prog === 1).map(fil => ({species : fil.species, national_tree_seed_prog: fil.national_tree_seed_prog})),
            tree_breeding_prog : region.data.filter(element => element.tree_breeding_prog === 1).map(fil => ({species : fil.species, tree_breeding_prog: fil.tree_breeding_prog})),
            area_seed_stands : region.data.map(rec => + rec.area_seed_stands).reduce((partialSum, a) => partialSum + a, 0),
            number_seed_stands : region.data.map(rec =>  + rec.number_seed_stands).reduce((partialSum, a) => partialSum + a, 0),
            area_seed_orchards : region.data.map(rec =>  + rec.area_seed_orchards).reduce((partialSum, a) => partialSum + a, 0),
            number_seed_orchards : region.data.map(rec => + rec.number_seed_orchards).reduce((partialSum, a) => partialSum + a, 0),
            planting_stock_year : region.data.map(rec => + rec.planting_stock_year).reduce((partialSum, a) => partialSum + a, 0),
            
          }
        ));

        // console.log(regionalValues);
        // console.log(uniqueSpecies.length);
         setDataSelected(regionalValues); 
         setDataRefactored(true);
      
            };
          };
      
         refactorData();
     }, [props.lang, props.data, dataSelected, globalUniqueASpeciesCount ]);
   
   
   
       return (
       <React.Fragment>   
       
              <br></br> 
              {Array.isArray(dataSelected) && 
           dataSelected!== undefined && 
           dataSelected !== null && dataSelected.length > 0  && Array.isArray(totalLineData) && 
           totalLineData !== undefined && totalLineData !== null && totalLineData.length > 0 ? 
          <div>
     
        
   <br/>
        <br/>
        <div style={{display: "flex", justifyContent: "start", alignItems: "baseline"}}>
        <span style={{margin: "1rem"}}>{globalUniqueASpeciesCount} {t('species_reported')} </span> 
         <span> {dataAllSpeciesToDownload !== null && <DownloadSpeciesData type="species" questionnairePart = "species" data={dataAllSpeciesToDownload} page="all-countries"/>}</span> 
        </div>
        {/* <div style={{display: "flex", justifyContent: "end", alignItems: "baseline"}}>
        <span className="legend-element table-grey-column-non-bold-text" >{t('legend_only')}:
       <span style={{marginRight:  "1rem", marginLeft: "1rem"} }> 
       <img  style={{marginRight: props.lang === "ar" ? "1rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0.5rem"} }fill="red" src={process.env.PUBLIC_URL + `/img/circle_YES.svg`} alt="arrow down icon" />{t('legend_yes')}</span>
     <img  style={{marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft:  "0.2rem"} } fill="red" src={process.env.PUBLIC_URL + `/img/circle_NO.svg`} alt="arrow down icon" />{t('legend_no')}</span>
     
    </div> */}
    <br/>
   <ButtonToolbar aria-label="Toolbar with button groups">
      <ButtonGroup  aria-label="First group">
        <Button onClick ={() => setSelectedSection(1) } className={`button-${selectedSection === 1 ? "is-active" : "is-not-active"}`} variant="light" style={{ marginRight:"1rem", marginBottom: "0.3rem"}}> <h1 className="data-button">{t('species_table_heading_1')}</h1></Button> 
        <Button onClick ={() => setSelectedSection(2) } className={`button-${selectedSection === 2 ? "is-active" : "is-not-active"}`} variant="light"  style={{marginRight:"1rem", marginBottom: "0.3rem"}}> <h1 className="data-button">{t('species_table_heading_2')}</h1></Button> 
        <Button onClick ={() => setSelectedSection(3) } className={`button-${selectedSection === 3 ? "is-active" : "is-not-active"}`} variant="light"  style={{ marginRight:"1rem", marginBottom: "0.3rem"}}> <h1 className="data-button">{t('species_table_heading_3')}</h1></Button> 
        <Button onClick ={() => setSelectedSection(4) } className={`button-${selectedSection === 4 ? "is-active" : "is-not-active"}`} variant="light"  style={{marginBottom: "0.3rem",  marginRight: props.lang === "ar" ? "1rem" : "0rem"}}> <h1 className="data-button">{t('species_table_heading_4')}</h1></Button> 
      </ButtonGroup>
    </ButtonToolbar>
    <div className="wrapper">
        <Table  borderless 
         style ={{ borderSpacing: "0",borderCollapse: "collapse",
         borderStyle: "hidden", marginBottom: "0px",  
         borderBottom:"0px solid trasparent !important", 
         borderBottomWidth: "0"}} >
            <thead>
             <tr >
             <th colSpan={3}  style={{backgroundColor:"#F7F8F9", borderRight:"0.5px solid rgb(187, 186, 186)", minWidth: "200px" }} scope="col">{t('menu_item_species')}</th>
             {selectedSection  === 1 ? <th colSpan={3}  style={{backgroundColor:"#B9DDF1", borderRight:"0.5px solid rgb(187, 186, 186)", borderBottom:"0.5px solid rgb(187, 186, 186)" }} scope="col">{t('species_table_heading_1')}</th> :
          selectedSection  === 2 ? <th colSpan={3}  style={{backgroundColor:"#BCE4D8", borderRight:"0.5px solid rgb(187, 186, 186)", borderBottom:"0.5px solid rgb(187, 186, 186)" }} scope="col">{t('species_table_heading_2')}</th> :
         selectedSection === 3 ? <th colSpan={4}  style={{backgroundColor:"#D5E8AF", borderRight:"0.5px solid rgb(187, 186, 186)", borderBottom:"0.5px solid rgb(187, 186, 186)"  }}scope="col">{t('species_table_heading_3')}</th> :
         <th colSpan={8}  style={{backgroundColor:"#B3E0A6", borderBottom:"0.5px solid rgb(187, 186, 186)" }} scope="col">{t('species_table_heading_4')}</th>}
        
       </tr> 
       <tr style={{height: "40px"  }}  >
       <th  colSpan={3} style={{backgroundColor:"#F7F8F9", minWidth: "200px"   }}  scope="col"></th>
        
       {selectedSection  === 1 && <th style={{backgroundColor:"#B9DDF1", minWidth: "100px"}}  scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_11')}</p></th>}
       {selectedSection  === 1 &&  <th style={{backgroundColor:"#B9DDF1", minWidth: "100px"}} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_12')}</p></th> }
        {selectedSection  === 1 &&  <th style={{backgroundColor:"#B9DDF1", minWidth: "100px", borderRight:"0.5px solid rgb(187, 186, 186)"  }} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_13')}</p></th>}
     
 
        {selectedSection  === 2 &&   <th  style={{backgroundColor:"#BCE4D8", minWidth: "100px"}} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_21')}</p></th>}
        {selectedSection  === 2 &&  <th  style={{backgroundColor:"#BCE4D8", minWidth: "100px" }} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_22')}</p></th>}
        {selectedSection  === 2 &&   <th  style={{backgroundColor:"#BCE4D8", minWidth: "100px", borderRight:"0.5px solid rgb(187, 186, 186)"}} scope="col"><p className="new-sub-heading">{t('thousands_species_table_sub_heading_23')}</p></th>}

        {selectedSection  === 3 && <th  style={{backgroundColor:"#D5E8AF", minWidth: "100px" }} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_31')}</p></th> }
        {selectedSection  === 3 && <th  style={{backgroundColor:"#D5E8AF", minWidth: "100px" }} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_32')}</p></th> }
        {selectedSection  === 3 && <th  style={{backgroundColor:"#D5E8AF", minWidth: "100px" }} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_33')}</p></th> }
        {selectedSection  === 3 && <th  style={{backgroundColor:"#D5E8AF", minWidth: "100px", borderRight:"0.5px solid rgb(187, 186, 186)"  }} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_34')}</p></th>}

      
        {selectedSection  === 4 && <th  style={{backgroundColor:"#B3E0A6", minWidth: "50px"}} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_41')}</p></th>}
        {selectedSection  === 4 && <th  style={{backgroundColor:"#B3E0A6", minWidth: "50px"}} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_42')}</p></th>}
        {selectedSection  === 4 && <th  style={{backgroundColor:"#B3E0A6" , minWidth: "80px"}} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_43')}</p></th>}
        {selectedSection  === 4 && <th  style={{backgroundColor:"#B3E0A6", minWidth: "50px" }} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_44')}</p></th>}
        {selectedSection  === 4 && <th  style={{backgroundColor:"#B3E0A6", minWidth: "50px" }} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_45')}</p></th>}
        {selectedSection  === 4 && <th  style={{backgroundColor:"#B3E0A6", minWidth: "50px"}} scope="col"><p className="new-sub-heading">{t('species_table_sub_heading_46')}</p></th>}
        {selectedSection  === 4 &&<th  style={{backgroundColor:"#B3E0A6", minWidth: "70px" }} scope="col"><p className="new-sub-heading">{t('thousands_species_table_sub_heading_47')}</p></th>}
        {selectedSection  === 4 && <th  style={{backgroundColor:"#B3E0A6", minWidth: "80px"  }} scope="col"><p className="new-sub-heading" >{t('species_table_sub_heading_48')}</p></th> }

       </tr>
     </thead>
        
         <tbody >
         <tr key="totalWorld"> 
         <td  colSpan={3} 
         style={{position: "sticky", backgroundColor:"rgb(226, 222, 222)",  minWidth: "200px", borderTop:"0.5px solid rgb(187, 186, 186)", borderRight:"0.5px solid rgb(187, 186, 186)"}} >
          <p className="target-indicator-country-total-title">{t('species_total')}</p></td>
         
            {selectedSection  === 1 &&    
          <td style={{backgroundColor:"rgb(226, 222, 222)",
            minWidth: "100px", borderTop:"0.5px solid rgb(187, 186, 186)", paddingLeft: "30px",
            textAlign: "center"}}>
             <p className="target-indicator-text">{dataSelected.map(elem => 
             elem.national_distribution_available.filter((o, index, arr) => 
             arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
             partialSum + a.national_distribution_available, 0)).reduce((partialSum, a) => 
              partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
             </p></td> 
       } 
         {selectedSection  === 1 &&  
          <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "100px", paddingLeft: "28px",
            borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} >
              <p className="target-indicator-text">{dataSelected.map(elem => 
             elem.non_molecular_characterization.filter((o, index, arr) => 
             arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
             partialSum + a.non_molecular_characterization, 0)).reduce((partialSum, a) => 
              partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>  
       }
         {selectedSection  === 1 &&      
         <td style={{backgroundColor:"rgb(226, 222, 222)",
            minWidth: "100px", borderTop:"0.5px solid rgb(187, 186, 186)", 
            paddingLeft: "28px",textAlign: "center"}} >
              <p className="target-indicator-text">{dataSelected.map(elem => 
             elem.molecular_characterization.filter((o, index, arr) => 
             arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
             partialSum + a.molecular_characterization, 0)).reduce((partialSum, a) => 
              partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       
        {selectedSection  === 2 &&     
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "100px", paddingLeft: "28px",
            borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
            className="target-indicator-text">{dataSelected.map(elem => 
              elem.in_situ_programme.filter((o, index, arr) => 
              arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
              partialSum + a.in_situ_programme, 0)).reduce((partialSum, a) => 
               partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}


       {selectedSection  === 2 &&      
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "100px", 
                  borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
                  className="target-indicator-text">{dataSelected.map(elem => elem.number_situ_units).reduce((partialSum, a) => 
                    partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       
       {selectedSection  === 2 &&     
       <td style={{backgroundColor:"rgb(226, 222, 222)",  
                minWidth: "100px", borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
                className="target-indicator-text">{(dataSelected.map(elem => elem.area_in_situ).reduce((partialSum, a) => 
                  partialSum + a, 0)/1000).toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}

       {selectedSection  === 3 &&     
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "100px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
       className="target-indicator-text">{dataSelected.map(elem => 
        elem.ex_situ_programme.filter((o, index, arr) => 
        arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
        partialSum + a.ex_situ_programme, 0)).reduce((partialSum, a) => 
         partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 3 &&    
        <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "100px", 
        borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
        className="target-indicator-text">{dataSelected.map(elem => elem.number_ex_situ).reduce((partialSum, a) => 
          partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 3 &&   
        <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "100px",
        borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
        className="target-indicator-text">{dataSelected.map(elem => elem.area_ex_situ).reduce((partialSum, a) => 
          partialSum + a, 0).toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 3 &&   
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "100px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
       className="target-indicator-text">{dataSelected.map(elem => elem.number_ex_situ_accessions).reduce((partialSum, a) => 
        partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       
       
       {selectedSection  === 4 &&   
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "50px", 
        borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}}><p 
       className="target-indicator-text">{dataSelected.map(elem => 
        elem.national_tree_seed_prog.filter((o, index, arr) => 
        arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
        partialSum + a.national_tree_seed_prog, 0)).reduce((partialSum, a) => 
         partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&   
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "50px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
       className="target-indicator-text">{dataSelected.map(elem => 
        elem.tree_breeding_prog.filter((o, index, arr) => 
        arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
        partialSum + a.tree_breeding_prog, 0)).reduce((partialSum, a) => 
         partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&   
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "80px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
       className="target-indicator-text">{dataSelected.map(elem => elem.area_seed_stands).reduce((partialSum, a) => 
        partialSum + a, 0).toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&    
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "50px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
       className="target-indicator-text">{dataSelected.map(elem => elem.number_seed_stands).reduce((partialSum, a) => 
        partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&    
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "50px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
       className="target-indicator-text">{dataSelected.map(elem => elem.area_seed_orchards).reduce((partialSum, a) => 
        partialSum + a, 0).toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&    
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "50px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
       className="target-indicator-text">{dataSelected.map(elem => elem.number_seed_orchards).reduce((partialSum, a) => 
        partialSum + a, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&    
       <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "70px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
       className="target-indicator-text">{(dataSelected.map(elem => elem.planting_stock_year).reduce((partialSum, a) => 
        partialSum + a, 0)/1000).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td> }
       {selectedSection  === 4 &&   
        <td style={{backgroundColor:"rgb(226, 222, 222)",  minWidth: "80px",
        borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
        className="target-indicator-text">-</p></td>} 


       </tr>
         {
       totalLineData.map((region, index) => 
         <tr key={region.replaceAll(' ', '')}>
         <td  colSpan={3} 
         style={{position: "sticky", backgroundColor:"#F7F8F9",  minWidth: "200px", borderTop:"0.5px solid rgb(187, 186, 186)", borderRight:"0.5px solid rgb(187, 186, 186)"}} >
          <p className="target-indicator-summary-title">{
          region === "LAC" ? 
            t('region_lac') : 
          region === "N America" ? 
          t('region_north_america') : 
          region === "SW Pacific" ? 
          t('region_swpacific') : 
          region === "Africa" ?  
          t('region_africa') : 
          region === "Europe" ?
          t('region_europe') :  
          region === "Asia" ? 
          t('region_asia') :
          t('region_neareast')}</p></td>
         
            {selectedSection  === 1 &&    
          <td style={{backgroundColor:"#F7F8F9",
            minWidth: "100px", borderTop:"0.5px solid rgb(187, 186, 186)", paddingLeft: "30px",
            textAlign: "center"}}>
             <p className="target-indicator-text">{dataSelected[index].national_distribution_available.filter((o, index, arr) => 
             arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
             partialSum + a.national_distribution_available, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
             </p>
             </td> 
       } 
         {selectedSection  === 1 &&  
          <td style={{backgroundColor:"#F7F8F9",  minWidth: "100px", paddingLeft: "28px",
            borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} >
              <p className="target-indicator-text">{dataSelected[index].non_molecular_characterization.filter((o, index, arr) => 
             arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
             partialSum + a.non_molecular_characterization, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>  
       }
         {selectedSection  === 1 &&      
         <td style={{backgroundColor:"#F7F8F9",
            minWidth: "100px", borderTop:"0.5px solid rgb(187, 186, 186)", 
            paddingLeft: "28px",textAlign: "center"}} >
              <p className="target-indicator-text">{dataSelected[index].molecular_characterization.filter((o, index, arr) => 
             arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
             partialSum + a.molecular_characterization, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       
        {selectedSection  === 2 &&     
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "100px", paddingLeft: "28px",
            borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
            className="target-indicator-text">{dataSelected[index].in_situ_programme.filter((o, index, arr) => 
              arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
              partialSum + a.in_situ_programme, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}


       {selectedSection  === 2 &&      
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "100px", 
                  borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
                  className="target-indicator-text">{dataSelected[index].number_situ_units.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       
       {selectedSection  === 2 &&     
       <td style={{backgroundColor:"#F7F8F9",  
                minWidth: "100px", borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
                className="target-indicator-text">{(dataSelected[index].area_in_situ/1000).toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}

       {selectedSection  === 3 &&     
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "100px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
       className="target-indicator-text">{dataSelected[index].ex_situ_programme.filter((o, index, arr) => 
        arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
        partialSum + a.ex_situ_programme, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 3 &&    
        <td style={{backgroundColor:"#F7F8F9",  minWidth: "100px", 
        borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
        className="target-indicator-text">{dataSelected[index].number_ex_situ.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 3 &&   
        <td style={{backgroundColor:"#F7F8F9",  minWidth: "100px",
        borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
        className="target-indicator-text">{dataSelected[index].area_ex_situ.toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 3 &&   
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "100px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
       className="target-indicator-text">{dataSelected[index].number_ex_situ_accessions.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       
       
       {selectedSection  === 4 &&   
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "50px", 
        borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}}><p 
       className="target-indicator-text">{dataSelected[index].national_tree_seed_prog.filter((o, index, arr) => 
        arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
        partialSum + a.national_tree_seed_prog, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&   
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "50px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
       className="target-indicator-text">{dataSelected[index].tree_breeding_prog.filter((o, index, arr) => 
        arr.findIndex(item => item.species === o.species) === index).reduce((partialSum, a) => 
        partialSum + a.tree_breeding_prog, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&   
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "80px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
       className="target-indicator-text">{dataSelected[index].area_seed_stands.toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&    
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "50px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
       className="target-indicator-text">{dataSelected[index].number_seed_stands.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&    
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "50px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
       className="target-indicator-text">{dataSelected[index].area_seed_orchards.toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&    
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "50px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
       className="target-indicator-text">{dataSelected[index].number_seed_orchards.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td>}
       {selectedSection  === 4 &&    
       <td style={{backgroundColor:"#F7F8F9",  minWidth: "70px", 
       borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center" }} ><p 
       className="target-indicator-text">{(dataSelected[index].planting_stock_year/1000).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</p></td> }
       {selectedSection  === 4 &&   
        <td style={{backgroundColor:"#F7F8F9",  minWidth: "80px",
        borderTop:"0.5px solid rgb(187, 186, 186)", textAlign: "center"}} ><p 
        className="target-indicator-text">-</p></td>} 


       </tr>
         ) }
        
   
         </tbody>
       </Table>
       </div>  
       <br></br>

       </div>: null}
         </React.Fragment>
       );
     }
   
     export default SpeciesGlobalRegionalCoverageTable;


 